import { render, staticRenderFns } from "./VideoListComp.vue?vue&type=template&id=37e22137&scoped=true&"
import script from "./VideoListComp.vue?vue&type=script&lang=js&"
export * from "./VideoListComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e22137",
  null
  
)

export default component.exports